/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface CreatorDto
 */
export interface CreatorDto {

    /**
     * Identifier of the related entity
     *
     * @type {number}
     * @memberof CreatorDto
     * @example 1
     */
    id: number;

    /**
     * @type {string}
     * @memberof CreatorDto
     */
    firstName: string | null;

    /**
     * @type {string}
     * @memberof CreatorDto
     */
    lastName: string | null;
}
